import { uniqBy } from 'lodash';
import { orderBy } from 'lodash/collection';
import { isEmpty } from 'lodash/lang';

export function toRequestFilters(ssu, therapeuticArea, indication) {
  const studyIds = getSelectedIds(ssu.selectedStudies);
  const siteIds = getSelectedIds(ssu.selectedSites);
  const therapeuticAreaValues = getSelectedIds(therapeuticArea?.value);
  const indicationValues = getSelectedIds(indication?.value);

  return {
    studyIds: isEmpty(studyIds) ? null : studyIds,
    siteIds: isEmpty(siteIds) ? null : siteIds,
    therapeuticAreas: isEmpty(therapeuticAreaValues) ? null : therapeuticAreaValues,
    indications: isEmpty(indicationValues) ? null : indicationValues
  };
}

export function hasActiveFilters(requestObject) {
  return (
    !isEmpty(requestObject.studyIds) ||
    !isEmpty(requestObject.siteIds) ||
    !isEmpty(requestObject.therapeuticAreas) ||
    !isEmpty(requestObject.indications)
  );
}

export function getUniqueSitesFromStudySites(studySites) {
  const sites = studySites.map(s => s.site);
  return orderBy(uniqBy(sites, 'id'), 'name', 'asc');
}

function getSelectedIds(collection) {
  return !isEmpty(collection) ? collection.map(e => e.id) : [];
}
